import { render, staticRenderFns } from "./EWUserDetailShow.vue?vue&type=template&id=c47891f4&scoped=true&"
import script from "./EWUserDetailShow.vue?vue&type=script&lang=js&"
export * from "./EWUserDetailShow.vue?vue&type=script&lang=js&"
import style0 from "./EWUserDetailShow.vue?vue&type=style&index=0&id=c47891f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47891f4",
  null
  
)

export default component.exports